import { toNumber, get, head } from 'lodash-es';
import { select, put } from 'redux-saga/effects';
import { collectionSelector, userIdSelector, getVideosPerPageSelector } from 'common/selectors';
import { myVideoDeletedVideoIdSelector } from 'pages/my-videos.page';
import { getVideoIdSelector } from 'components/video-box/selectors';
import { urlSortSelector } from 'common/selectors/router';
import { history } from 'app.history';
import { collectionSetInStoreAction } from 'common/actions';
import { myVideosFetchApi } from 'common/api';

const isLastVideoInCollection = (deletedVideoId, collection) => {
  let isIt = false;
  if (!collection) return false;
  if (collection.videos.length === 1 && collection.videos[0].id === deletedVideoId) {
    isIt = true;
  }
  return isIt;
};

export function* postDeleteEffect({ payload }) {
  try {
    const pageNumber = toNumber(get(payload, 'pageNumber', 1));
    const collection = yield select(collectionSelector);
    const userId = yield select(userIdSelector);
    const focusedVideoId = yield select(getVideoIdSelector);
    const deletedVideoId = yield select(myVideoDeletedVideoIdSelector);
    const deletedIsLast = isLastVideoInCollection(deletedVideoId, collection);
    const nextPageNumber = deletedIsLast && pageNumber >= 1 ? pageNumber - 1 : pageNumber;

    const perPage = yield select(getVideosPerPageSelector);
    const sorting = yield select(urlSortSelector);
    const nextCollection = yield myVideosFetchApi({ userId, pageNum: nextPageNumber, perPage, sorting });
    yield put(collectionSetInStoreAction(nextCollection));

    const nextFocusedVideoId =
      deletedVideoId === focusedVideoId ? get(head(nextCollection.videos), 'id', '') : focusedVideoId;

    if (nextFocusedVideoId) {
      history.push(`/my-videos/${nextPageNumber}/${nextFocusedVideoId}`);
    } else if (nextPageNumber) {
      history.push(`/my-videos/${nextPageNumber}`);
    } else {
      history.push('/my-videos');
    }
  } catch (error) {}
}
